import { format, parseISO } from "date-fns";

export type ProfileFormState = {
  FirstName: string;
  LastName: string;
  MailAddress: string;
  Phonenumber: string;
  Street: string;
  PostalCode: string;
  City: string;
  Birthdate: string;
  ReceiveNewsletter: boolean;
  LastQualification: string;
  Emoji: string;
};

export const initialProfileFormState: ProfileFormState = {
  FirstName: "",
  LastName: "",
  MailAddress: "",
  Phonenumber: "",
  Street: "",
  PostalCode: "",
  City: "",
  Birthdate: "",
  ReceiveNewsletter: false,
  LastQualification: "",
  Emoji: "",
};

export function toDateInputValue(d?: string | Date): string {
  if (!d) return "";
  const parsed =
    typeof d === "string" ? (d.includes("T") ? parseISO(d) : new Date(d + "T00:00:00")) : d;
  if (isNaN(parsed.getTime())) return "";
  return format(parsed, "yyyy-MM-dd");
}
